import { useState, useEffect, useRef } from "react";


function Home() {
    const [isHovered, setIsHovered] = useState(false);
    // const [showPopup, setShowPopup] = useState(true);
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.play().catch(error => console.log("Autoplay prevented:", error));
        }
    }, []);

    return (
        <div className="home-div min-h-screen flex flex-col">

            {/* Header Section */}
            <div className="home-photo-div relative flex flex-col lg:flex-row items-center justify-center text-center py-16 px-4">

                {/* Video Section */}
                <div
                    className="relative w-full overflow-hidden mb-6 md:mb-0 flex justify-center"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <video
                        ref={videoRef}
                        src="/assets/photos/Graded Video 4.mp4"
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="w-full max-w-[700px] lg:max-w-[600px] mt-6 lg:w-full lg:-ml-[40rem] rounded-xl object-cover"
                        controls={isHovered}
                    />
                </div>

                {/* Welcome Section */}
                <div className="welcome-title-div flex-1 translate-x-[-60px] lg:-ml-[40rem]">
                    <div>
                        <h1 className="welcome-title text-4xl md:text-6xl max-w-2xl font-extrabold text-olive mb-4 drop-shadow-md shadow-slate-900">
                            Welcome to Wonder Kids Academy
                        </h1>

                        <p className="welcome-statement text-2xl text-navy opacity-90 mb-4  mx-auto lg:text-3xl">
                            Where Faith, Learning, and Joyful Discovery Shine Bright
                        </p>

                        <a
                            href="https://api.leadconnectorhq.com/widget/bookings/wonder-kids-academy"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="tour-button mt-5 text-xl font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out">
                                Schedule A Tour
                            </button>
                        </a>
                    </div>
                </div>

            </div>

            {/* Lower School Section  */}
            <div className="caps-section flex mt-20 items-center justify-center bg-gradient-to-br from-stone-100 to-stone-200 px-4 py-12">
                
                <div className="w-full max-w-6xl text-center bg-white rounded-2xl shadow-xl border border-stone-200 p-8">

                    <h1 className="text-navy text-2xl mt-10 md:text-3xl font-bold mb-4 tracking-tight">
                     Now Enrolling: GA Pre-K Program
                    </h1>

                    <div className="w-16 h-1 bg-olive mx-auto mb-6 rounded-full"></div>

                    <h3 className="text-base text-gray-700 font-medium leading-relaxed mb-5">
                    We’re growing! Wonder Kids Academy is excited to expand our impact by now offering Georgia Pre-K program. This next step allows us to continue walking alongside your child’s educational journey with excellence, intentionality, and a strong foundation in faith.
                    </h3>

                    <h3 className="text-base text-gray-700 font-medium leading-relaxed mb-5">
                    Our GA Pre-K program provides a high-quality, state-funded early learning experience designed to prepare children for long-term academic success.
                    </h3>

                    <h3 className="text-base font-semibold text-navy leading-relaxed mb-4">
                    At Wonder Kids Academy, we don’t just prepare children for the next grade, we prepare them for purpose.
                    </h3>

                    <h3 className="text-sm text-gray-600 leading-relaxed mb-6">
                    Take the first step to securing your child’s seat today and click the link below.
                    </h3>

                    <a
                    href="https://form.jotform.com/260954578162163"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    <button className="mt-3 mb-10 text-lg font-semibold text-white bg-olive px-6 py-3 rounded-full shadow-md hover:shadow-xl hover:-translate-y-1 hover:bg-olive/90 transition duration-300 ease-in-out">
                        Enroll Today
                    </button>
                    </a>

                </div>
                <div 
                    className="hidden relative w-full overflow-hidden mb-6 md:mb-0"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <video
                        ref={videoRef}
                        src="/assets/photos/Graded Video 1.mp4"
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="hidden w-full ml-40 max-w-[700px] lg:w-full rounded-xl object-cover mx-auto"
                        controls={isHovered}
                    />
                </div>
            </div>


            {/* Welcome About Section */}
            <div className="welcome-about flex justify-center items-center py-16 px-6 md:px-12 bg-stone-100 xs:mt-20">
                <img rel="preload" src="/assets/photos/HFH09302.jpg" alt="placeholder" className="different-points-image hidden lg:flex mb-4 w-2/6 h-full rounded-xl xs:w-3/4 lg:w-80 lg:mr-20"/>
                <div className="text-center max-w-3xl mx-auto">
                    <p className="welcome-about-text text-lg text-gray-800 mb-6 leading-relaxed">
                        At Wonder Kids Academy, we believe that every child is a unique creation of God, full of potential and purpose. Our mission is
                        to nurture young hearts and minds in a Christ-centered environment, equipping them with the tools they need to thrive
                        academically, spiritually, and emotionally.
                    </p>
                    <p className="welcome-about-text text-lg text-gray-800 mt-6 leading-relaxed lg:mt-20">
                        Through a blend of faith-based instruction, engaging curriculum, and loving care, we create a safe and inspiring space where
                        children can explore, grow, and wonder about the beauty of God’s world.
                    </p>
                </div>
                <img rel="preload" src="/assets/photos/HFH08863.jpg" alt="placeholder" className="different-points-image hidden lg:flex mb-4 w-2/6 rounded-xl lg:w-60 lg:ml-20"/>
            </div>

        </div>
    );
}

export default Home;
